import { render, staticRenderFns } from "./editBuygetType.vue?vue&type=template&id=64b7e688&scoped=true"
import script from "./editBuygetType.vue?vue&type=script&lang=js"
export * from "./editBuygetType.vue?vue&type=script&lang=js"
import style0 from "./editBuygetType.vue?vue&type=style&index=0&id=64b7e688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7e688",
  null
  
)

export default component.exports